import { PLAN_IDS } from '@/config/plans'

export const isEnterprisePlan = (planId: string): boolean => {
	return planId.toLowerCase() === PLAN_IDS.ENTERPRISE.toLowerCase()
}

export const getPlanDisplayName = (planId: string): string => {
	const planMap: Record<string, string> = {
		[PLAN_IDS.BASIC]: 'Basic',
		[PLAN_IDS.PRO]: 'Pro',
		[PLAN_IDS.ENTERPRISE]: 'Enterprise',
	}
	return planMap[planId.toLowerCase()] || planId
}
